


//function Formulaire({children,title,handleMouse,handleMouseleave,handlekeyUpgain,onclick,count,setCount,nom,postnom,prenom,sexe,telephone,Image,setNom,setPostnom,setPrenom,setSexe,setImage,setTelephone,setNomcomplet}){
    function Formulaire({ errors,handleEmailChange, setErrors, HandleSubmit_status,type,reinitialiser,message,email,setEmail,date_engagement,setDate_engagement,telephone,setTelephone,my_domaine,setMy_domaine,error_submission,submission,HandleSubmit,children,title,handlekeyUpgain,nom,postnom,prenom,sexe,date_naissance,lieu_naissance,setNom,setPostnom,setPrenom,setSexe,setDate_naissance,setLieu_naissance,setNom_complet,niveau,setNiveau,adresse,setAdresse}){
  
    return(
        <>
      <div className="container py-5">
  <div className="row justify-content-center">
    <div className="col-lg-10">
      {/* Carte principale */}
      <div className="card shadow-lg border-0 rounded-4">
        
        {/* En-tête avec titre et bouton reset */}
        <div className="card-header bg-white border-0 pt-4 pb-0 d-flex justify-content-between align-items-center px-4">
          <h3 className="fw-bold text-light mb-0">
            <i className="bi bi-person-plus-fill me-2"></i> {title}
          </h3>
          {
            type==="update" && (
                <button 
                    type="button" 
                    onClick={()=>reinitialiser(nom,prenom)} 
                    className="btn btn-outline-warning btn-sm rounded-pill px-3 shadow-sm"
                >
                    <i className="bi bi-arrow-counterclockwise"></i> Réinitialiser le mot de passe
                </button>
            )
          }
          
        </div>

        <div className="card-body p-4">
          <form>
            {/* --- SECTION 1 : IDENTITÉ --- */}
            <h6 className="text-uppercase text-muted fw-bold mb-3 small">Informations Personnelles</h6>
            <div className="row g-3 mb-4">
              <div className="col-md-4">
                <label className="form-label fw-semibold">Nom</label>
                <input type="text" className="form-control form-control-lg bg-light" placeholder="Nom" value={nom} onChange={(e)=>setNom(e.target.value.toLowerCase())} onBlur={(e)=>setNom_complet(e.target.value.toLowerCase() +" "+postnom+" "+prenom)} onKeyUp={handlekeyUpgain} />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-semibold">Postnom</label>
                <input type="text" className="form-control form-control-lg bg-light" placeholder="Postnom" value={postnom} onChange={(e)=>setPostnom(e.target.value.toLowerCase())} onBlur={(e)=>setNom_complet(nom +" "+e.target.value.toLowerCase()+" "+prenom)} />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-semibold">Prénom</label>
                <input type="text" className="form-control form-control-lg bg-light" placeholder="Prénom" value={prenom} onChange={(e)=>setPrenom(e.target.value.toLowerCase())} onBlur={(e)=>setNom_complet(nom +" "+postnom+" "+e.target.value.toLowerCase())} />
              </div>
            </div>

            <div className="row g-3 mb-4">
              <div className="col-md-3">
                <label className="form-label fw-semibold">Genre</label>
                <select className="form-select form-select-lg bg-light" value={sexe} onChange={(e)=>setSexe(e.target.value)}>
                  <option value="" disabled>Choisir...</option>
                  <option value="M">Homme</option>
                  <option value="F">Femme</option>
                </select>
              </div>
              <div className="col-md-5">
                <label className="form-label fw-semibold">Email</label>
                <input type="email" className="form-control form-control-lg bg-light" placeholder="exemple@mail.com" value={email} onChange={handleEmailChange} />
                  {errors?.email && (
                  <span style={{ color: "red", display: "block" }}>
                    {errors?.email[0] === "The email has already been taken." 
                      ? "Cet email est déjà associé à un autre compte" 
                      : errors?.email[0]=== "The email field must be a valid email address." ? "Veuillez saisir une adresse email valide." : errors?.email[0] }
                  </span>
                )}
              </div>
              <div className="col-md-4">
                <label className="form-label fw-semibold">Téléphone</label>
                <div className="input-group">
                  <span className="input-group-text bg-light">+243</span>
                  <input type="number" className="form-control form-control-lg bg-light" placeholder="8..." value={telephone} onChange={(e)=>{const value=e.target.value; if(value.length<=9){setTelephone(value)}}} />
                </div>
              </div>
            </div>

            {/* --- SECTION 2 : PARCOURS --- */}
            <hr className="my-4 opacity-25" />
            <h6 className="text-uppercase text-muted fw-bold mb-3 small">Origine & Niveau</h6>
            
            <div className="row g-3 mb-4">
              <div className="col-md-6">
                <label className="form-label fw-semibold">Lieu de naissance</label>
                <input type="text" className="form-control form-control-lg bg-light" value={lieu_naissance} onChange={(e)=>setLieu_naissance(e.target.value.toLowerCase())} />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-semibold">Date de naissance</label>
                <input type="date" className="form-control form-control-lg bg-light" value={date_naissance} onChange={(e)=>setDate_naissance(e.target.value)} />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-semibold">Engagement</label>
                <input type="date" className="form-control form-control-lg bg-light" value={date_engagement} onChange={(e)=>setDate_engagement(e.target.value)} />
              </div>
            </div>

            <div className="row g-3 mb-4">
              <div className="col-md-6">
                <label className="form-label fw-semibold">Adresse Résidentielle</label>
                <input type="text" className="form-control form-control-lg bg-light" placeholder="N°, Avenue, Quartier..." value={adresse} onChange={(e)=>setAdresse(e.target.value.toLowerCase())} />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-semibold">Niveau d'étude</label>
                <select className="form-select form-select-lg bg-light" value={niveau} onChange={(e)=>setNiveau(e.target.value)}>
                  <option value="" disabled>Niveau...</option>
                  <option value="D6">D6</option>
                  <option value="GRADUAT">GRADUAT</option>
                  <option value="LICENCE">LICENCE</option>
                  <option value="MASTER">MASTER</option>
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label fw-semibold">Domaine</label>
                <select className="form-select form-select-lg bg-light" onChange={(e)=>setMy_domaine(e.target.value)}>
                  <option value="" disabled>Domaine...</option>
                  <option value="MATH-PHYSIQUE">MATH-PHYSIQUE</option>
                  <option value="HISTOIRE">HISTOIRE</option>
                  <option value="GEOGRAPHIE">GEOGRAPHIE</option>
                  <option value="FRANCAIS">FRANCAIS</option>
                </select>
              </div>
            </div>

            {/* Zone pour d'éventuels composants enfants */}
            <div className="row mb-3">
                {children}
            </div>

            {/* --- ALERTES ET MESSAGES --- */}
            {error_submission && (
              <div className="alert alert-danger border-0 shadow-sm d-flex align-items-center mb-3" role="alert">
                <i className="bi bi-exclamation-circle-fill me-2"></i>
                <div>Veuillez compléter tous les champs obligatoires</div>
              </div>
            )}

            {submission && (
              <div className="alert alert-success border-0 shadow-sm d-flex align-items-center mb-3" role="alert">
                <i className="bi bi-check-circle-fill me-2"></i>
                <div>{message}</div>
              </div>
            )}

            {/* --- BOUTON D'ACTION --- */}
            <div className="d-grid mt-4">
              <button 
                type="button" 
                className="btn btn-primary btn-lg fw-bold shadow rounded-3 py-3" 
                onClick={HandleSubmit}
              >
                {
                  HandleSubmit_status && (
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  ) 
                }
                <i className="bi bi-cloud-arrow-up-fill me-2"></i> Enregistrer les informations
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
        </>
    )
}
export default Formulaire;